// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__ijtFm","label":"Category_label__2FU8C","content":"Category_content__zvhq6","header":"Category_header__BsFyM","location":"Category_location__3VKV3"};